module.exports = __webpack_public_path__ + "static/media/icons-16.3c1c220e.woff";